<template>
  <div class="rb-ob-form rb-match-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.rematchDecideTitle') }}</h1>
    </header>

    <p class="rb-ob-q">{{ $t('intake.rematchDecideQuestion') }}</p>
    <p v-if="loading" class="rb-ob-status" role="status">{{ $t('intake.portal.loading') }}</p>
    <p v-else-if="!error && !rematch" class="rb-ob-status" role="status">{{ $t('intake.rematchNoneActive') }}</p>

    <div class="rb-ob-choice-grid rb-match-choice-stack">
      <div class="rb-ob-choice" :class="{ 'is-selected': choice === 'seeOthers' }">
        <button class="rb-ob-choice-select" type="button" :disabled="loading || !rematch" @click="choose('seeOthers')">
          <span class="rb-ob-choice-body">
            <span class="rb-ob-choice-title">{{ $t('intake.rematchSeeOthers') }}</span>
          </span>
        </button>
      </div>
      <div class="rb-ob-choice" :class="{ 'is-selected': choice === 'stay' }">
        <button class="rb-ob-choice-select" type="button" :disabled="loading || !rematch" @click="choose('stay')">
          <span class="rb-ob-choice-body">
            <span class="rb-ob-choice-title">{{ $t('intake.rematchStayCurrent') }}</span>
            <span class="rb-ob-choice-hint">{{ $t('intake.rematchStayHint') }}</span>
          </span>
        </button>
      </div>
    </div>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" :disabled="loading || !rematch" @click="continuePrimary">
        {{ $t(choice === 'stay' ? 'intake.rematchStayCurrent' : 'intake.rematchAcceptAction') }}
      </button>
      <p v-if="error" class="rb-ob-err is-visible" role="alert">{{ error }}</p>
      <button v-if="error && !rematch" class="rb-ob-submit rb-ob-submit-secondary" type="button" :disabled="loading" @click="bootstrap">{{ $t('intake.rematchRetryAction') }}</button>
      <router-link class="rb-ob-submit rb-ob-submit-secondary" :to="{name: 'portalHome', params: {lang: $route.params.lang || 'fa'}}">{{ $t('intake.rematchBackToCareAction') }}</router-link>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {fetchActiveClinicalResponse, decideClinicalRematch} from '@/intake/portalApi'

export default {
  name: 'RematchDecideStep',
  data() {
    return {
      choice: 'seeOthers',
      rematch: null,
      loading: true,
      error: '',
    }
  },
  mounted() {
    this.bootstrap()
  },
  methods: {
    bootstrap() {
      this.loading = true
      this.error = ''
      this.rematch = null
      return fetchActiveClinicalResponse().then((data) => {
        this.rematch = data && data.rematch ? data.rematch : null
        if (!this.rematch) return
        if (!this.rematch.id) throw new Error('REMATCH_STATUS_UNAVAILABLE')
        if (this.rematch.status !== 'OFFERED') this.$router.replace({name: 'intakeRematchRun', params: {lang: this.$route.params.lang || 'fa'}})
      }).catch(() => { this.error = this.$t('intake.rematchStatusUnavailable') }).finally(() => { this.loading = false })
    },
    choose(value) {
      if (this.loading) return
      this.choice = value
    },
    continuePrimary() {
      return this.persistChoice(this.choice)
    },
    persistChoice(value) {
      if (this.loading || !this.rematch || !this.rematch.id) return
      this.loading = true
      this.error = ''
      const decision = value === 'seeOthers' ? 'accept' : 'decline'
      return decideClinicalRematch(this.rematch.id, decision)
          .then((result) => {
            const confirmed = result && (result.rematch || result)
            if (!confirmed || String(confirmed.id) !== String(this.rematch.id)) throw new Error('REMATCH_DECISION_UNCONFIRMED')
            if (decision === 'accept') {
              if (['MANUAL_REVIEW_REQUIRED', 'FINANCIAL_RESOLUTION_REQUIRED', 'SAFETY_APPROVAL_REQUIRED', 'SAFETY_BLOCKED'].includes(confirmed.status)) {
                this.$router.replace({name: 'intakeRematchRun', params: {lang: this.$route.params.lang || 'fa'}})
                return
              }
              if (!['ACCEPTED_PENDING_REQUIREMENTS', 'MATCH_FAILED', 'NO_SUPPLY', 'MATCH_READY'].includes(confirmed.status)) throw new Error('REMATCH_DECISION_UNCONFIRMED')
              // A fresh screening finalization is mandatory before clinical rematch matching.
              this.$router.replace({name: 'intakeScreening', params: {lang: this.$route.params.lang || 'fa'}, query: {restart: '1'}})
            } else {
              if (confirmed.status !== 'DECLINED') throw new Error('REMATCH_DECISION_UNCONFIRMED')
              this.goHome()
            }
          })
          .catch(() => { this.error = this.$t('intake.rematchDecisionFailed') })
          .finally(() => { this.loading = false })
    },
    goHome() {
      this.$router.push({
        name: 'portalHome',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
  },
}
</script>
